// extracted by mini-css-extract-plugin
module.exports = {"OrgDialogModalBase":"OrgDialogModal_OrgDialogModalBase__1rHvy","OrgDialogModalItem":"OrgDialogModal_OrgDialogModalItem__2xrhq"};